import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {AuthTokenService} from "../services/auth-token.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
              private authTokenService: AuthTokenService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    const profile = this.authTokenService.profile;
    const expired = this.authTokenService.isExpired;  

    const hasProfile = Array.isArray(profile)
      ? profile.includes('MEDICO') || profile.includes('TI')
      : profile === 'MEDICO' || profile === 'TI';

    if (!expired && hasProfile) {
      return true;
    } else {
      this.authTokenService.clearAll();
      this.router.navigate(['/']);
      return false;
    }
  }
}
